import { render } from "./HSelect.vue?vue&type=template&id=08e227aa&scoped=true"
import script from "./HSelect.vue?vue&type=script&lang=js"
export * from "./HSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e227aa"]])

export default __exports__